import { render, staticRenderFns } from "./SpallaVideo.vue?vue&type=template&id=22eddbf8&scoped=true&"
import script from "./SpallaVideo.vue?vue&type=script&lang=js&"
export * from "./SpallaVideo.vue?vue&type=script&lang=js&"
import style0 from "./SpallaVideo.vue?vue&type=style&index=0&id=22eddbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eddbf8",
  null
  
)

export default component.exports